import React, { Fragment } from "react";
import GreenLogo from "../Innovators/GreenLogo";
import RedLogo from "../Mentors/RedLogo";
import BlueLogo from "../Employers/BlueLogo";

const UnfollowUserConfirm = ({
  user: { role, avatar, firstname, lastname, jobtitle, location },
  unfollowedUser,
  setShowUnfollowUser,
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="subscription-box-confirmation">
          <i
            className={`far fa-times-circle fa-3x subscription-x ${
              unfollowedUser.role === "innovator"
                ? "green"
                : unfollowedUser.role === "mentor"
                ? "red"
                : unfollowedUser.role === "employer"
                ? "blue"
                : null
            }`}
            onClick={() =>
              setShowUnfollowUser({ request: false, confirm: false })
            }
          ></i>
          <div className="subscription-type-container">
            <p className="nav-logo">
              {unfollowedUser.role === "innovator" ? (
                <GreenLogo />
              ) : unfollowedUser.role === "mentor" ? (
                <RedLogo />
              ) : unfollowedUser.role === "employer" ? (
                <BlueLogo />
              ) : null}
            </p>
            <h1
              className={`subscription-name ${
                unfollowedUser.role === "innovator"
                  ? "green"
                  : unfollowedUser.role === "mentor"
                  ? "red"
                  : unfollowedUser.role === "employer"
                  ? "blue"
                  : null
              }`}
            >
              Un-Follow User
            </h1>
          </div>
          <div className="sub-grid-three">
            <div className="subscription-user">
              <div className="sub-section-container">
                <div className="flex-only">
                  <i
                    className={`fas fa-user-circle mr-5 fa-lg mt-5 ${
                      unfollowedUser.role === "innovator"
                        ? "green"
                        : unfollowedUser.role === "mentor"
                        ? "red"
                        : unfollowedUser.role === "employer"
                        ? "blue"
                        : null
                    }`}
                  ></i>
                  <p
                    className={`sub-section ${
                      unfollowedUser.role === "innovator"
                        ? "green"
                        : unfollowedUser.role === "mentor"
                        ? "red"
                        : unfollowedUser.role === "employer"
                        ? "blue"
                        : null
                    }`}
                  >
                    Request to un-follow user:
                  </p>
                </div>
              </div>
              <div className="sub-user">
                <div className="online-avi-container">
                  <div
                    className={`avi-color-border-alt ${
                      unfollowedUser.role === "innovator"
                        ? "green"
                        : unfollowedUser.role === "mentor"
                        ? "red"
                        : unfollowedUser.role === "employer"
                        ? "blue"
                        : null
                    }`}
                  >
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${unfollowedUser.avatar}`}
                      className="sub-avi"
                      alt="avi"
                    />
                  </div>
                </div>
                <div className="sub-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span
                        className={`name-font bold ${
                          unfollowedUser.role === "innovator"
                            ? "green"
                            : unfollowedUser.role === "mentor"
                            ? "red"
                            : unfollowedUser.role === "employer"
                            ? "blue"
                            : null
                        }`}
                      >
                        {unfollowedUser.firstname} {unfollowedUser.lastname}
                      </span>
                    </li>
                    <li className="user-online-item">
                      {unfollowedUser.jobtitle}
                    </li>
                    <li className="user-online-item">
                      {unfollowedUser.location.city},{" "}
                      {unfollowedUser.location.state}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="subscription-user">
              <div className="sub-section-container">
                <div className="flex-only">
                  <i
                    className={`fas fa-user-circle mr-5 fa-lg mt-5 ${
                      unfollowedUser.role === "innovator"
                        ? "green"
                        : unfollowedUser.role === "mentor"
                        ? "red"
                        : unfollowedUser.role === "employer"
                        ? "blue"
                        : null
                    }`}
                  ></i>
                  <p
                    className={`sub-section ${
                      unfollowedUser.role === "innovator"
                        ? "green"
                        : unfollowedUser.role === "mentor"
                        ? "red"
                        : unfollowedUser.role === "employer"
                        ? "blue"
                        : null
                    }`}
                  >
                    Un-follow request from:
                  </p>
                </div>
              </div>
              <div className="sub-user">
                <div className="online-avi-container">
                  <div
                    className={`avi-color-border-alt ${
                      role === "innovator"
                        ? "green"
                        : role === "mentor"
                        ? "red"
                        : role === "employer"
                        ? "blue"
                        : null
                    }`}
                  >
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                      className="sub-avi"
                      alt="avi-two"
                    />
                  </div>
                </div>
                <div className="sub-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span
                        className={`name-font bold ${
                          role === "innovator"
                            ? "green"
                            : role === "mentor"
                            ? "red"
                            : role === "employer"
                            ? "blue"
                            : null
                        }`}
                      >
                        {firstname} {lastname}
                      </span>
                    </li>
                    <li className="user-online-item">{jobtitle}</li>
                    <li className="user-online-item">
                      {location.city}, {location.state}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="sub-grid">
            <p className="user-request-text">
              You have successfully unfollowed {unfollowedUser.firstname}{" "}
              {unfollowedUser.lastname} ({unfollowedUser.channelid}).
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default UnfollowUserConfirm;
